import { useNavigate } from 'react-router-dom';
import { IconPill, IconArrowRight } from '@tabler/icons-react';
import { useMedications } from '../../hooks/useMedications';
import { computeTopNames } from '../../utils/portalHelpers';

export function MedicationsSummaryCard() {
  const navigate = useNavigate();
  const { medicationsData, isLoading, error } = useMedications();

  const medCount = medicationsData.medications.length;
  const suppCount = medicationsData.supplements.length;
  const total = medCount + suppCount;
  const topNames = computeTopNames(medicationsData);

  return (
    <div className="card p-5 h-full">
      <div className="flex items-center gap-2 mb-3">
        <IconPill size={18} className="text-cyan-400" stroke={1.5} />
        <h3 className="text-sm font-semibold text-gray-100">Medications</h3>
      </div>

      {isLoading ? (
        <p className="text-xs text-gray-500">Loading...</p>
      ) : error ? (
        <p className="text-xs text-red-400 mb-3">Unable to load medications</p>
      ) : total > 0 ? (
        <>
          <p className="text-2xl font-bold text-gray-100 mb-1">{total}</p>
          <p className="text-xs text-gray-500 mb-3">
            {medCount} medication{medCount !== 1 ? 's' : ''}, {suppCount} supplement{suppCount !== 1 ? 's' : ''}
          </p>
          {topNames.length > 0 && (
            <div className="space-y-1 mb-3">
              {topNames.map((name, i) => (
                <p key={i} className="text-xs text-gray-400 truncate" title={name}>{name}</p>
              ))}
              {total > 3 && (
                <p className="text-xs text-gray-600">+{total - 3} more</p>
              )}
            </div>
          )}
        </>
      ) : (
        <p className="text-xs text-gray-500 mb-3">No medications or supplements recorded</p>
      )}

      <button
        onClick={() => navigate('/medications')}
        className="flex items-center gap-1 text-xs text-cyan-400 hover:text-cyan-300 transition-colors mt-auto"
      >
        View all <IconArrowRight size={12} />
      </button>
    </div>
  );
}
